import { render } from "./graphdiff.vue?vue&type=template&id=c3b71df0&scoped=true"
import script from "./graphdiff.vue?vue&type=script&lang=js"
export * from "./graphdiff.vue?vue&type=script&lang=js"

import "./graphdiff.vue?vue&type=style&index=0&id=c3b71df0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b71df0"]])

export default __exports__